import { Directive, ElementRef, Input } from '@angular/core';
@Directive({
  selector: '[innerHTMLBypassXSS]'
})
export class InnerHTMLBypassXSSDirective {

  @Input() set innerHTMLBypassXSS(content: string) {
    this.elementRef.nativeElement.innerHTML = content;
  }

  constructor(protected elementRef: ElementRef) {
  }
}
